import { useMemo } from "react";
import { diffWords } from "diff";
import { Box, Typography } from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import IButton from "../../../components/iconButton";
import { ChangeCard, LABEL } from "./style";

// Deletions recede, insertions come forward. Colour is doing almost nothing
// here on purpose — strikethrough and weight carry the diff, so it survives
// both themes and reads the same to anyone who can't separate red from green.
const REMOVED = {
  color: "text.disabled",
  textDecoration: "line-through",
  textDecorationThickness: "1px",
};

const ADDED = {
  color: "text.primary",
  fontWeight: 500,
  bgcolor: "background.dark",
  borderRadius: "3px",
  px: "2px",
};

export default function EditCard({ edit, index, stale, text, onApply, onReject }) {
  const parts = useMemo(() => diffWords(edit.find, edit.replace), [edit]);

  return (
    <ChangeCard
      className={stale ? "stale" : ""}
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <Typography sx={{ ...LABEL, mb: 0.75 }}>
        {edit.note || text.change}
      </Typography>

      <Box
        dir="auto"
        sx={{ fontSize: "0.875rem", lineHeight: 1.75, wordBreak: "break-word" }}
      >
        {parts.map((part, i) => (
          <Box
            key={i}
            component="span"
            sx={part.removed ? REMOVED : part.added ? ADDED : { color: "text.secondary" }}
          >
            {part.value}
          </Box>
        ))}
      </Box>

      {stale ? (
        <Typography
          variant="caption"
          sx={{ display: "block", mt: 1, color: "text.disabled" }}
        >
          {text.stale}
        </Typography>
      ) : (
        <Box sx={{ display: "flex", gap: 1, mt: 1.25 }}>
          <IButton
            size="small"
            variant="contained"
            color="action"
            startIcon={<CheckRoundedIcon fontSize="small" />}
            onClick={onApply}
          >
            {text.apply}
          </IButton>
          <IButton
            size="small"
            color="inherit"
            startIcon={<CloseRoundedIcon fontSize="small" />}
            onClick={onReject}
            sx={{ color: "text.secondary" }}
          >
            {text.reject}
          </IButton>
        </Box>
      )}
    </ChangeCard>
  );
}
